export default {
  home: 'Home',
  login: 'Login',
  system_setting: 'System Setting',
  menu_setting: 'Menu Setting',
  user_setting: 'User Setting',
  auth_setting: 'Auth Setting',
  logs: 'Logs',
  apps_setting: 'Apps Setting',
  apps_group: 'Apps Group',
  apps_list: 'Apps List',
  interface_setting: 'Interface Setting',
  interface_group: 'Interface Group',
  interface_list: 'Interface List',
  add_button: 'Add',
  find_button: 'Find',
  refresh_button: 'Refresh',
  delete_button: 'Delete',
  edit_button: 'Edit',
  open_choose: 'Open',
  close_choose: 'Close',
  show_choose: 'Show',
  hide_choose: 'Hide',
  interface_request: 'Request Params',
  interface_response: 'Response Params',
  user_center: 'User Center',
  wiki_list: 'Wiki Center',
  wiki_error: 'Wiki Error',
  wiki_calculation: 'Wiki Calculation',
  wiki_login: 'Wiki Login',

  用户登录:'User login',
  用户登出:'User logout',
  系统管理:'system management',
  菜单维护:'Menu maintenance',
  菜单状态修改:'Menu status modification',
  新增菜单:'Add menu',
  编辑菜单:'Edit menu',
  菜单删除:'Menu delete',
  角色管理:'Role management',
  获取当前组的全部用户:'Get all users of the current group',
  用户状态修改:'User status modification',
  新增用户:'New user',
  用户编辑:'User editing',
  用户删除:'User delete',
  权限管理:'Authority management',
  权限组状态编辑:'Permission group status editing',
  从指定组中删除指定用户:'Removes the specified user from the specified group',
  新增权限组:'Add permission group',
  权限组编辑:'Permission group editing',
  删除权限组:'Delete permission group',
  获取全部已开放的可选组:'Get all open optional groups',
  获取组所有的权限列表:'Get the permission list of all groups',
  应用接入:'Application access',
  应用管理:'Application management',
  应用状态编辑:'Application status editing',
  获取AppIdAppSecret接口列表应用接口权限细节:'Get appidappsecret interface list and application interface permission details',
  新增应用:'New application',
  编辑应用:'Edit application',
  删除应用:'Delete app',
  接口管理:'Interface management',
  接口维护:'Interface maintenance',
  接口状态编辑:'Interface status editing',
  获取接口唯一标识:'Get the unique ID of the interface',
  添加接口:'Add interface',
  编辑接口:'Edit interface',
  删除接口:'Delete interface',
  获取接口请求字段:'Get interface request field',
  获取接口返回字段:'Get interface return field',
  添加接口字段:'Add interface field',
  上传接口返回字段:'Upload interface return field',
  编辑接口字段:'Edit interface fields',
  删除接口字段:'Delete interface field',
  接口分组:'Interface grouping',
  添加接口组:'Add Interface Group',
  编辑接口组:'Edit Interface Group',
  删除接口组:'Delete Interface Group',
  获取全部有效的接口组:'Get all valid interface groups',
  接口组状态维护:'Interface group status maintenance',
  应用分组:'Application grouping',
  添加应用组:'Add application group',
  编辑应用组:'Edit application group',
  删除应用组:'Delete application group',
  获取全部可用应用组:'Get all available application groups',
  应用组状态编辑:'Application group status editing',
  菜单列表:'Menu list',
  用户列表:'User list',
  权限列表:'Permission list',
  应用列表:'Application List',
  应用分组列表:'Application group list',
  接口列表:'Interface list',
  接口分组列表:'Interface grouping list',
  日志管理:'Log management',
  获取操作日志列表:'Get operation log list',
  删除单条日志记录:'Delete a single log record',
  刷新路由:'Refresh route',
  文件上传:'File upload',
  更新个人信息:'Update personal information',
  刷新AppSecret:'Refresh appsecret',
  获取用户信息:'Get user information',
  编辑权限细节:'Edit permission details',
  获取用户有权限的菜单:'Get the menu for which the user has permission',
  系统支撑:'System support',
  用户管理:'user management ',
  会员列表:'Member list',
  在线会员:'Online member',



}
